import { render } from "./MultiselectEditor.vue?vue&type=template&id=046da202&scoped=true"
import script from "./MultiselectEditor.vue?vue&type=script&lang=js"
export * from "./MultiselectEditor.vue?vue&type=script&lang=js"

import "./MultiselectEditor.vue?vue&type=style&index=0&id=046da202&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-046da202"]])

export default __exports__